export default {
    INITIAL: 'initial',
    FOCUS: 'focus',
    ERROR: 'error',
    SUCCESS: 'success',
};
